import { createSelector } from "reselect"
import { get, last } from "lodash"
import { getRawTopic } from "modules/research-topic-root/selectors"
import { getSavedMetrics, getSavedCompositionGroup, getSavedTopicSummaryGroup, getHedges, getSelectedExperiment } from "."
import { getRefInstrumentEvaluateAs } from "./instrument"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}
export const getLastestUploadedDate = state => get(state, "global.data.instrumentPortfolioModelMeta.data.dates.0")
export const getEarliestUploadedDate = state => last(get(state, "global.data.instrumentPortfolioModelMeta.data.dates"))

export const getRawComparisonItems = state => get(state, "modules.researchTopic.comparisonItems", EMPTY_ARRAY)
export const getSelectedComparisonType = (state) => get(state, "modules.researchTopic.selectedComparisonType", EMPTY_OBJECT)

export const getSelectedSettings = createSelector(
  [getRawComparisonItems, getSavedMetrics, getSavedCompositionGroup, getSelectedComparisonType, getSavedTopicSummaryGroup, getHedges, getRefInstrumentEvaluateAs],
  (comparisonItems, savedMetrics, savedCompositionGroup, selectedComparisonType, savedTopicSummaryGroup, hedges, refInstrumentEvaluateAs) => ({
    comparisonItems,
    hedges,
    selectedComparisonType,
    savedMetrics,
    savedCompositionGroup,
    savedTopicSummaryGroup,
    refInstrumentEvaluateAs,
  }),
)
export const getCurrentTopicId = createSelector(
  [getRawTopic],
  (topic) => get(topic, "id"),
)
export const getExperimentPositionSet = createSelector(
  [getCurrentTopicId, getSelectedExperiment],
  (topicId, selectedExperiment) => selectedExperiment ? ({ type: "RESEARCH_TOPIC", id: topicId, experimentId: selectedExperiment.id }) : null,
)
